import UserActivityLogsPage from "../../component/users/dynamic-users/UserActivityLogs"

 
function UserActivityLogs() {
  return (
    <div className="page-body"><UserActivityLogsPage/></div>
  )
}

export default UserActivityLogs